export default "__VITE_ASSET__CQc0HY_L__"